<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请选择跟进方式"
          v-model="searchCondition.followupType"
          style="width: 200px"
          filterable
        >
          <el-option label="电话" value="phone"></el-option>
          <el-option label="短信" value="sms"></el-option>
        </el-select>
        <el-cascader
          ref="cascader"
          clearable
          v-model="searchCondition.orgCode"
          :props="props"
          placeholder="请选择导购机构"
          :show-all-levels="false"
          size="small"
          class="mr10"
        ></el-cascader>

        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入手机号/导购工号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择跟进时间段筛选"
          end-placeholder="请选择跟进时间段筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '导购联系记录')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="职员姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workNum"
          label="导购工号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="导购机构"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="客户姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="客户电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="followupTime"
          label="跟进时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="followupType"
          label="跟进方式"
        >
          <template slot-scope="scope">
            {{ scope.row.followupType === "phone" ? "电话" : "短信" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="left"
          prop="followupContent"
          label="跟进内容/备注"
          width="300"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.followupContent"></div>
            <!-- <el-popover placement="top-start" width="200" trigger="hover">
              <div v-html="scope.row.followupContent"></div>
              <span slot="reference">
                <i class="hmicon icon-wenhao"></i>
              </span>
            </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="nextFollowupTime"
          label="下次跟进时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="记录人"
        ></el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchCondition: {},
      list: [{}],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.followupStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.followupEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      if (typeof searchCondition.orgCode == "object") {
        searchCondition.orgCode =
          searchCondition.orgCode[searchCondition.orgCode.length - 1];
      }
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryFollowupRecordList",
        params
      );
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.followupStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.followupEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      if (typeof searchCondition.orgCode == "object") {
        searchCondition.orgCode =
          searchCondition.orgCode[searchCondition.orgCode.length - 1];
      }
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllFollowupRecordList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.records;
            list.forEach(v => {
              if (v.followupType === "phone") {
                v.followupType = "电话";
              } else {
                v.followupType = "短信";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped></style>
